import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteBlacklistAddress = async (id: number): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteAddress($id: Float!) {
        deleteAddress(id: $id) {
          id
        }
      }
    `),
    variables: {
      id,
    },
  });

  return !!response.data?.deleteAddress;
};
